import { useQuery } from "react-query";
import {
  getAccountActivities,
  Activity,
  FilterType,
} from "../services/accounts/activities";
import { usePaginationResult, PAGE_SIZE } from "../../hooks/usePagination";
import { usePagination } from "../../hooks";

export type useAccountActivitiesResult = usePaginationResult<Activity>;

export const useAccountActivities = (
  accountNumber: string,
  startPage?: number,
  type?: FilterType,
): useAccountActivitiesResult => {
  const { setPage, page } = usePagination(
    `accounts/${accountNumber}/activities/${type}`,
    {
      page: startPage,
    },
  );
  const { isFetching, status, error, data } = useQuery(
    ["accounts/activities", { page, size: PAGE_SIZE, type, accountNumber }],
    getAccountActivities,
    {
      enabled: !!accountNumber,
    },
  );

  return {
    //Pagination Handlers
    page,
    setPage,
    pageSize: PAGE_SIZE,
    // Request Handlers
    status,
    isFetching,
    error,
    data: data?.results,
    count: data?.totalCount,
  };
};
